import { decodeToken } from "../../utils/settings";
import { GetMeAction, getProfilePicture } from "../Onboarding/auth/action";
import { fetchToken } from "../../firebase";
import { initializeCleverTapAndTrackUser } from "../../utils/clevertap";
import {
  fetchEntity,
  fetchSuppliers,
} from "../../v3/Common/Entity/actions/reduxActions";
import storeModule from "../../utils/store";

export const onLoggedIn = async ({
  data,
  message,
  navigate = () => {},
  dispatch = () => {},
  toast = () => {},
}) => {
  const getTokenData = async () => {
    const decoded = await decodeToken();
    return {
      firmOnboarded: decoded?.default_company_info
    };
  };

  if (data && data?.token) {
    localStorage.setItem('token', data.token);
    const { error: userError, data: loggedInUser } = await GetMeAction();
    fetchToken();
    const { firmOnboarded } = await getTokenData();
    if (!userError && loggedInUser) {
      const url = getProfilePicture(loggedInUser?.profile_picture_details);  
      if (typeof url !== 'object') {
        dispatch({
          type: 'SET_USER',
          data: { ...loggedInUser, profile_image: url },
        });
      } else{
        dispatch({ type: 'SET_USER', data: loggedInUser });
      }
      if (firmOnboarded) {
        await dispatch(fetchSuppliers());
        const { selectedSupplier } = storeModule.store.getState().entityReducer;
        if (selectedSupplier) {
          await dispatch(
            fetchEntity(
              firmOnboarded.company_id,
              selectedSupplier,
              "ALL_MODULES",
            ),
          );
        }
      }
      const userProfileForCleverTap = {
        ...loggedInUser,
        access_type: 'full_app',
        pwa_module: false
      };
      try {
        await initializeCleverTapAndTrackUser(userProfileForCleverTap);
      } catch (error) {
        // Don't block the login flow if CleverTap fails
      }
      navigate('/');
    } else {
      return toast.error(message);
    }
  } else {
    return toast.error(message);
  }
};
